<template>
    <div >
        <CustomCallout       
        :has-toggle="false"
        class="mt-2 deep"
        :border-color-hex="value.statusColor"
        >
            <div class="row mt-2 pb-3">
                <div class="col-md-6 col-lg-2 pt-3">
                    <div class="row d-flex justify-content-start">
                        <div class="col-8 rounded-pill p-2 text-center":style="{ backgroundColor: value.statusColor }">
                            <span class="font-weight-bold">{{ value.status }}</span>
                        </div>
                        <div class="col-10 mt-2">
                            <span class="font-weight-bold">{{value.relatedRequest || "-"}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-8 pt-3 border-left">
                    <div class="row pl-3">
                     <div class="col-md-4">
                        <div class="info-text-title text-gray">Solicitud Relacionada:</div> 
                            <strong>{{value.hrRequestNumber || "-" }}</strong>
                        </div>
                        <div class="col-md-3">
                        <div class="info-text-title text-gray">Nombre del Estudiante:</div>
                            <strong>{{ value.studentName }}</strong>
                        </div>    
                        <div class="col-md-5">
                        <div class="info-text-title text-gray">Necesidad(es):</div>
                            <strong>{{ value.necesities }}</strong>
                        </div>
                    </div>
              </div>
            </div>
        </CustomCallout>
    </div>
</template>
  
<script>


import CustomCallout from "custom-callout";

export default {
    name: "SaeeRow",
    components: {
        CustomCallout
    },
    props:{
        value:null
    },
};
</script>

<style scoped>
.tab__container {
  padding: 20px 30px;
}

.action-buttons__container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
}

.dot-icon__container {
  padding: 3px 5px;
  border-radius: 50%;
  box-shadow: 0 3px 6px #00000029;
  background: #fff 0 0 no-repeat padding-box;
}

::v-deep .custom-text-area__container textarea {
  min-height: 50px !important;
}
</style>